// Thin adapter so every component written against Next's <Link href="...">
// API keeps working unchanged under react-router, which expects `to`.
import { Link as RouterLinkBase, type LinkProps as RouterLinkProps } from "react-router-dom";

type Props = Omit<RouterLinkProps, "to"> & { href: string };

export default function Link({ href, ...rest }: Props) {
  return <RouterLinkBase to={href} {...rest} />;
}
